import * as React from "react";
import style from "./style.module.scss";

interface AspectCardProps {
  aspect?: number;
  className?: string;
  active: string | boolean;
  cover?: boolean;
  children?: React.ReactNode;
  sos?: boolean
}

const AspectCard: React.FC<AspectCardProps> = (props: AspectCardProps) => {
  const { aspect = 0.55, className, children, active, cover, sos } = props;

  if (cover) {
    return (
      <div
        className={`${style.box} ${className || ""} ${
          active ? style.active : ""
        }`}
        style={{ width: "100%", height: "100%" }}
      >
        <div className={`${style.container} ${ sos ? style.bg_sos : style.bg_default }`}>{children}</div>
      </div>
    );
  }

  return (
    <div
      className={`${style.box} ${className || ""} ${
        active ? style.active : ""
      }`}
    >
      <div className={style.back} style={{ paddingBottom: `${aspect * 100}%` }}>
        {" "}
      </div>
      <div className={`${style.container} ${ sos ? style.bg_sos : style.bg_default }`}>{children}</div>
    </div>
  );
};

export default AspectCard;
